import axios from 'axios'

export const signUpApi = (data) => {
  return axios.post(
    `${process.env.REACT_APP_BE_URL}/serviceProvider`,
    data
  )
}
